export default "__VITE_ASSET__BIQ3D6TK__"